/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const shield_lock = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2 3.851v4.442c0 2.874 1.77 5.45 4.452 6.482l.607.234a1.75 1.75 0 0 0 1.257 0l.607-.234a6.946 6.946 0 0 0 4.452-6.482V3.851a.867.867 0 0 0-.506-.794 12.658 12.658 0 0 0-5.181-1.056 12.658 12.658 0 0 0-5.182 1.056.867.867 0 0 0-.506.794Z"
      clipRule="evenodd"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.063 8.75a1.5 1.5 0 0 1 1.5-1.5h2.25a1.5 1.5 0 0 1 1.5 1.5v1.376a1.5 1.5 0 0 1-1.5 1.5h-2.25a1.5 1.5 0 0 1-1.5-1.5V8.75Z"
      clipRule="evenodd"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.688 4.626a1.75 1.75 0 0 0-1.75 1.75v.875h3.5v-.875a1.75 1.75 0 0 0-1.75-1.75Z"
      clipRule="evenodd"
    />
  </svg>
)
export default shield_lock
